module.exports = __webpack_public_path__ + "fonts/DMSans-Regular.3e7f038b.ttf";